import React from 'react'
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared'
/**
 * @function OpenAnAccountPage
 * @return {React.Component}
 * @exported true
 * @description The main component for OpenAnAccountPage
 */
export default function OpenAnAccountPage(props) {
  return (
    <PageContainer className="open-an-account-page">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Open An Account"/>
          {/* Page content goes here */}
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
